import { healthBand, healthComment } from "@/lib/health-score";

/** Μικρός χρωματιστός κύκλος με το σκορ — πάνω δεξιά στην εικόνα της κάρτας. */
export function HealthScoreCircle({ score, className = "" }: { score: number; className?: string }) {
  const band = healthBand(score);
  return (
    <span
      title={`Σκορ υγείας: ${score}/100 — ${band.label}`}
      aria-label={`Σκορ υγείας ${score} στα 100, ${band.label}`}
      className={`grid h-8 w-8 place-items-center rounded-full text-xs font-extrabold shadow-md ring-2 sm:h-9 sm:w-9 sm:text-[13px] ${band.circleClass} ${className}`}
    >
      {score}
    </span>
  );
}

function scrollToNutrition() {
  const el = document.getElementById("nutrition-facts");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

/** Παιχνιδιάρικο πλαίσιο με το γενικό σκορ και έξυπνο σχόλιο. Κλικ → διατροφικά στοιχεία. */
export function HealthScoreBanner({ score, className = "" }: { score: number; className?: string }) {
  const band = healthBand(score);
  return (
    <button
      type="button"
      onClick={scrollToNutrition}
      aria-label={`Σκορ υγείας ${score} στα 100 — δες τα διατροφικά στοιχεία`}
      className={`flex w-full items-center gap-3 rounded-3xl border-2 p-3 text-left shadow-sm transition hover:shadow-md active:scale-[0.99] ${band.panelClass} ${className}`}
    >
      <div className="relative shrink-0">
        <span className={`grid h-12 w-12 place-items-center rounded-full text-base font-extrabold shadow ring-4 sm:h-14 sm:w-14 sm:text-lg ${band.circleClass}`}>
          {score}
        </span>
        <span className="absolute -bottom-1 -right-1 text-lg">{band.emoji}</span>
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-extrabold">
          {band.label} <span className="font-semibold opacity-70">· {score}/100</span>
        </div>
        <div className="text-xs leading-snug opacity-90">{healthComment(score)}</div>
        <div className="mt-1.5 h-1.5 w-full max-w-[220px] overflow-hidden rounded-full bg-black/10">
          <div className={`h-full rounded-full ${band.barClass}`} style={{ width: `${Math.max(4, Math.min(100, score))}%` }} />
        </div>
        <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-white/70 px-3 py-1 text-[11px] font-bold shadow-sm">
          Περισσότερες πληροφορίες →
        </span>
      </div>
    </button>
  );
}

/** Κύκλος σκορ συστατικών (καλλυντικά/καθαριστικά) — με μικρό 🧴. */
export function IngredientScoreCircle({ score, className = "" }: { score: number; className?: string }) {
  const band = healthBand(score);
  return (
    <span
      title={`Σκορ συστατικών: ${score}/100`}
      aria-label={`Σκορ συστατικών ${score} στα 100`}
      className={`relative grid h-8 w-8 place-items-center rounded-full text-xs font-extrabold shadow-md ring-2 sm:h-9 sm:w-9 sm:text-[13px] ${band.circleClass} ${className}`}
    >
      {score}
      <span className="absolute -bottom-1 -right-1 text-[11px] leading-none">🧴</span>
    </span>
  );
}
